import { pr } from "aaa";
import * as React from "react";

export const DownloadButton = ({ children, onClick, style }: { children: string, onClick: () => void, style?: React.CSSProperties }) => {
    return (
        <div
            role="button"
            onClick={onClick}
            className="theme-secondary-action-label-color"
            style={{ display: "flex", alignItems: "center", fontWeight: 600, fontSize: 14, cursor: "pointer", padding: "8px 16px", ...style }}
        >
            <pr.IconDownload style={{ marginRight: 8 }} />
            <span>{children}</span>
        </div>
    );
};


// WEBPACK FOOTER //
// ./src/components/BSPOptions/components/DownloadButton.tsx